(() => {
  async function getCards(url){
    try{
      const r=await fetch(url,{credentials:'same-origin'});
      if(!r.ok) return [];
      const html=await r.text();
      const box=document.createElement('div');
      box.innerHTML=html;
      return [...box.querySelectorAll('.dhc-product-card, article')];
    }catch(_){ return []; }
  }

  async function fill(section){
    const grid=section.querySelector('[data-dhc-recommendations-content]');
    const source=section.querySelector('[data-dhc-recommendations][data-dhc-fill-existing="true"]');
    if(!grid || !source) return;

    let existing=[...grid.children].length;
    if(existing>=5) return;

    const seen=new Set(
      [...grid.querySelectorAll('a[href*="/products/"]')]
        .map(a => (a.getAttribute('href')||'').split('?')[0])
    );

    let cards=await getCards(source.dataset.url);
    if(!cards.length) cards=await getCards(source.dataset.fallbackUrl);

    for(const card of cards){
      if(existing>=5) break;
      const a=card.querySelector('a[href*="/products/"]');
      const key=(a?.getAttribute('href')||'').split('?')[0];
      if(key && seen.has(key)) continue;
      if(key) seen.add(key);
      grid.appendChild(card);
      existing++;
    }
  }

  document.addEventListener('DOMContentLoaded',()=>{
    document.querySelectorAll('[data-dhc-live-complete-look="b85"]').forEach(fill);
  });
})();